module.exports = {"611022001":"龙驹寨街道","611022101":"庾岭镇","611022102":"蔡川镇","611022103":"峦庄镇","611022104":"铁峪铺镇","611022105":"武关镇","611022106":"竹林关镇","611022107":"土门镇","611022108":"寺坪镇","611022109":"商镇","611022110":"棣花镇","611022115":"花瓶子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/611022.json
// module id = 2885
// module chunks = 0